import { render, staticRenderFns } from "./entryPage.vue?vue&type=template&id=7996f10d&"
import script from "./entryPage.vue?vue&type=script&lang=js&"
export * from "./entryPage.vue?vue&type=script&lang=js&"
import style0 from "./entryPage.vue?vue&type=style&index=0&id=7996f10d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports